/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  SelectField,
  Text,
  TextField,
} from "@aws-amplify/ui-react";
import { ClimatePlanningHorizon } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function ClimatePlanningHorizonUpdateForm(props) {
  const {
    id: idProp,
    climatePlanningHorizon: climatePlanningHorizonModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    ClimatePlanningHorizonName: "",
    HorizonPeriodType: "",
    HorizonStart: "",
    HorizonEnd: "",
  };
  const [ClimatePlanningHorizonName, setClimatePlanningHorizonName] =
    React.useState(initialValues.ClimatePlanningHorizonName);
  const [HorizonPeriodType, setHorizonPeriodType] = React.useState(
    initialValues.HorizonPeriodType
  );
  const [HorizonStart, setHorizonStart] = React.useState(
    initialValues.HorizonStart
  );
  const [HorizonEnd, setHorizonEnd] = React.useState(initialValues.HorizonEnd);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = climatePlanningHorizonRecord
      ? { ...initialValues, ...climatePlanningHorizonRecord }
      : initialValues;
    setClimatePlanningHorizonName(cleanValues.ClimatePlanningHorizonName);
    setHorizonPeriodType(cleanValues.HorizonPeriodType);
    setHorizonStart(cleanValues.HorizonStart);
    setHorizonEnd(cleanValues.HorizonEnd);
    setErrors({});
  };
  const [climatePlanningHorizonRecord, setClimatePlanningHorizonRecord] =
    React.useState(climatePlanningHorizonModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(ClimatePlanningHorizon, idProp)
        : climatePlanningHorizonModelProp;
      setClimatePlanningHorizonRecord(record);
    };
    queryData();
  }, [idProp, climatePlanningHorizonModelProp]);
  React.useEffect(resetStateValues, [climatePlanningHorizonRecord]);
  const validations = {
    ClimatePlanningHorizonName: [],
    HorizonPeriodType: [],
    HorizonStart: [],
    HorizonEnd: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          ClimatePlanningHorizonName,
          HorizonPeriodType,
          HorizonStart,
          HorizonEnd,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(
            ClimatePlanningHorizon.copyOf(
              climatePlanningHorizonRecord,
              (updated) => {
                Object.assign(updated, modelFields);
              }
            )
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "ClimatePlanningHorizonUpdateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Climate Planning Horizons"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="NZCS1 paragraph 14a."
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Heading>
      <Text
        children="Update this record that defines your short, medium and long term climate planning horizons, then link them to your strategic planning horizons."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <TextField
        label="Climate planning horizon name"
        isRequired={false}
        isReadOnly={false}
        value={ClimatePlanningHorizonName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              ClimatePlanningHorizonName: value,
              HorizonPeriodType,
              HorizonStart,
              HorizonEnd,
            };
            const result = onChange(modelFields);
            value = result?.ClimatePlanningHorizonName ?? value;
          }
          if (errors.ClimatePlanningHorizonName?.hasError) {
            runValidationTasks("ClimatePlanningHorizonName", value);
          }
          setClimatePlanningHorizonName(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "ClimatePlanningHorizonName",
            ClimatePlanningHorizonName
          )
        }
        errorMessage={errors.ClimatePlanningHorizonName?.errorMessage}
        hasError={errors.ClimatePlanningHorizonName?.hasError}
        {...getOverrideProps(overrides, "ClimatePlanningHorizonName")}
      ></TextField>
      <SelectField
        label="Planning Horizon period"
        placeholder="Please select an option"
        isDisabled={false}
        value={HorizonPeriodType}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              ClimatePlanningHorizonName,
              HorizonPeriodType: value,
              HorizonStart,
              HorizonEnd,
            };
            const result = onChange(modelFields);
            value = result?.HorizonPeriodType ?? value;
          }
          if (errors.HorizonPeriodType?.hasError) {
            runValidationTasks("HorizonPeriodType", value);
          }
          setHorizonPeriodType(value);
        }}
        onBlur={() =>
          runValidationTasks("HorizonPeriodType", HorizonPeriodType)
        }
        errorMessage={errors.HorizonPeriodType?.errorMessage}
        hasError={errors.HorizonPeriodType?.hasError}
        {...getOverrideProps(overrides, "HorizonPeriodType")}
      >
        <option
          children="Current"
          value="Current"
          {...getOverrideProps(overrides, "HorizonPeriodTypeoption0")}
        ></option>
        <option
          children="Short term"
          value="Short_Term"
          {...getOverrideProps(overrides, "HorizonPeriodTypeoption1")}
        ></option>
        <option
          children="Medium term"
          value="Medium_Term"
          {...getOverrideProps(overrides, "HorizonPeriodTypeoption2")}
        ></option>
        <option
          children="Long term"
          value="Long_Term"
          {...getOverrideProps(overrides, "HorizonPeriodTypeoption3")}
        ></option>
        <option
          children="All climate planning horizons"
          value="All_Climate_Planning_Horizons"
          {...getOverrideProps(overrides, "HorizonPeriodTypeoption4")}
        ></option>
      </SelectField>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid6")}
      >
        <TextField
          label="Horizon start"
          isRequired={false}
          isReadOnly={false}
          type="date"
          value={HorizonStart}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                ClimatePlanningHorizonName,
                HorizonPeriodType,
                HorizonStart: value,
                HorizonEnd,
              };
              const result = onChange(modelFields);
              value = result?.HorizonStart ?? value;
            }
            if (errors.HorizonStart?.hasError) {
              runValidationTasks("HorizonStart", value);
            }
            setHorizonStart(value);
          }}
          onBlur={() => runValidationTasks("HorizonStart", HorizonStart)}
          errorMessage={errors.HorizonStart?.errorMessage}
          hasError={errors.HorizonStart?.hasError}
          {...getOverrideProps(overrides, "HorizonStart")}
        ></TextField>
        <TextField
          label="Horizon end"
          isRequired={false}
          isReadOnly={false}
          type="date"
          value={HorizonEnd}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                ClimatePlanningHorizonName,
                HorizonPeriodType,
                HorizonStart,
                HorizonEnd: value,
              };
              const result = onChange(modelFields);
              value = result?.HorizonEnd ?? value;
            }
            if (errors.HorizonEnd?.hasError) {
              runValidationTasks("HorizonEnd", value);
            }
            setHorizonEnd(value);
          }}
          onBlur={() => runValidationTasks("HorizonEnd", HorizonEnd)}
          errorMessage={errors.HorizonEnd?.errorMessage}
          hasError={errors.HorizonEnd?.hasError}
          {...getOverrideProps(overrides, "HorizonEnd")}
        ></TextField>
      </Grid>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || climatePlanningHorizonModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || climatePlanningHorizonModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
